import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../../services/loading.service';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { routeUrls } from '../../../constants/constants';
import { AdminSectionheaderComponent } from '../admin-sectionheader/admin-sectionheader.component';
import { AdminSidebarComponent } from '../admin-sidebar/admin-sidebar.component';
import { FooterComponent } from '../../../components/footer/footer-dashboard/footer.component';
import { SectionLoadingComponent } from '../../../components/section-loading/section-loading.component';

@Component({
  selector: 'cricteams-admin-layout',
  standalone: true,
  imports: [CommonModule,RouterModule,AdminSectionheaderComponent,AdminSidebarComponent,FooterComponent,SectionLoadingComponent],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
})
export class AdminLayoutComponent {
  public activeSidebar = true;
    public isSectionLoading = false;
    currentUrl = false;

    constructor(private loadingService: LoadingService, private router: Router, private commomService: CommonService) {
      this.loadingService.sectionLoading$.subscribe((sectionLoading) => {
        this.isSectionLoading = sectionLoading;
      });

      this.commomService.isLoaderBgTransparent.subscribe((isLoaderBgTransparent) => {
        if(isLoaderBgTransparent) {
          this.currentUrl = false;
        }
        if(!isLoaderBgTransparent) {
          this.currentUrl = true;
        }
      });
    }

    ngOnInit() {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.currentUrl = this.checkRoute(event.url);
        }
      });
    }
    toggleClass() {
      this.activeSidebar = !this.activeSidebar;
    }

    checkRoute(url:string) {
      switch (url) {
        case `/${routeUrls.ROOT}`:
        case `/${routeUrls.ADMIN_DASHBOARD}`:
        case `/${routeUrls.ADMIN_CLUBS}`:
        case `/${routeUrls.ADMIN}/${routeUrls.ADMIN_GROUNDS}`:
        case `/${routeUrls.ADMIN}/${routeUrls.ADMIN_LEAGUES}`:
        case `/${routeUrls.ADMIN}/${routeUrls.ADMIN_FEATURE_FLAGS}`:
          return true;
        default:
          return false;
      }
    }
}
